
import router from '../router/index'
export default {
  state: {
    menu: [],
    tabsList: [
      {
        path: '/homepage',
        name: 'homepage',
        label: '首页',
        icon: 'home'
      }
    ]
  },
  mutations: {
    setMenu(state, val) {
        state.menu = val
        let currentMenu = [
          {
            path: '/home',
            name:'home',
            component: () => import(`@/views/Home.vue`),
            children: [ {path:'/homepage',name:'homepage',component:()=>import('@/views/Homepage.vue') }]
          }
        ]
        val.forEach(item => {
          if (item.children) {
            item.children = item.children.map(item => {
              item.component = () => import(`@/views/${item.url}`)
              return item
            })
            currentMenu[0].children.push(...item.children)
          } else {
            item.component = () => import(`@/views/${item.url}`)
            currentMenu[0].children.push(item)
          }
        })
        console.log(currentMenu);
        router.addRoute(currentMenu)
        //router.addRoutes(currentMenu)
        localStorage.setItem("menu", JSON.stringify(val));
      },
      clearMenu(state) {
        state.menu = []
        localStorage.removeItem("menu");
      },
      selectMenu(state, val) {
        if (val.name !== 'home') {
          state.currentMenu = val
          let result = state.tabsList.findIndex(item => item.name === val.name)
          result === -1 ? state.tabsList.push(val) : ''
          localStorage.setItem("tagList", JSON.stringify(state.tabsList));
          //Cookie.set('tagList', JSON.stringify(state.tabsList))
        } else {
          state.currentMenu = null
        }
        // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
      },
      getMenu(state) {
        if ( localStorage.getItem('tagList')) {
          let tagList = JSON.parse(localStorage.getItem('tagList'))
          state.tabsList = tagList
        }
      },
  },
  actions: {}
}
